import { useEffect, useRef, useState } from 'react'

// import { sentrySetContext } from '../../tracking/sentry'
// import { transformToObject } from '../../utils/error'
// import { useBrowserService, useUserJourneyService } from '..'
// import { PageContext } from '../../../contexts/page-context'
// import { trackGA4PageView, trackContentInfo } from '../../tracking/google-tag-manager/events'
import { useCurrentUser } from '@lib/services/user/context'
import { feMetrics } from '@lib/tracking/metrics/femetrics'
import { ClientMetricsActions, GeneralClientMetrics } from '@lib/tracking/metrics/metrics'
import { transformToObject } from '@lib/utils/error'

import { logError, LogErrorMetrics } from '../../tracking/felog'
import { gnarClient, gnarSpec, setGnarUser } from '../../tracking/gnar'
// import { trackPerformance } from './track-performance'

export interface PageShowProps {
  pageId: string
  pageSlug: string
  isPreview?: boolean
  isStaticFallback?: boolean
  isCustom?: boolean
}

export const usePageShow = ({
  pageId,
  pageSlug,
  isPreview = false,
  isStaticFallback = false,
  isCustom = false,
}: PageShowProps) => {
  // const { user } = useCurrentUser()
  // const userJourney = useUserJourneyService()

  useEffect(() => {
    if (!isPreview) {
      void gnarSpec.pageShow({
        pageId,
        pageSlug,
        referrer: document.referrer,
        url: window.location.href,
        isCustomPage: isCustom,
        isStaticFallback,
      })
      // trackGA4PageView(user)
      // trackPerformance(pageId, pageSlug, document.referrer, window.location.href)

      logFeMetricsPageShow(pageSlug)
    }
  }, [pageId, pageSlug, isPreview, isStaticFallback])
  // }, [pageId, pageSlug, isPreview, isStaticFallback, user, userJourney])
}

// TODO: Add allow list for feMetrics page show in the future post launch
// const allowListFeMetricsPageShowPageSlug = new Set(['/', '/plans', '/superhuman-go-intro'])

const logFeMetricsPageShow = (pageSlug: string) => {
  feMetrics
    .getMetric(GeneralClientMetrics.Page)
    .getCounter(ClientMetricsActions.Show)
    .setContext({
      pageSlug,
    })
    .increment()
}

export const useGnarContainerId = () => {
  const [containerId, setContainerId] = useState('')
  const resolveRef = useRef<((value: string) => void) | null>(null)
  const [containerIdPromise] = useState(() => {
    return new Promise<string>(resolve => {
      resolveRef.current = resolve
    })
  })

  useEffect(() => {
    gnarClient
      .getContainerId()
      .then(id => {
        setContainerId(id)
        resolveRef.current?.(id)
      })
      .catch(_error => {
        logError(`Error getting Gnar container id`, LogErrorMetrics.GnarContainerIdFailed, {
          error: transformToObject(_error as Error),
        })

        // Return empty string as fallback
        resolveRef.current?.('')
      })
  }, [])

  return { containerId, containerIdPromise }
}

export const useTrackingInit = (_pageId: string, _pageSlug: string) => {
  const { user } = useCurrentUser()
  // const { browserName } = useBrowserService()

  // trackContentInfo(browserName)

  useEffect(() => {
    setGnarUser(user)
  }, [])

  useEffect(() => {
    // If the request fails, user will still be a None user. How should we handle tracking in that case?
    if (!user.isNone) {
      setGnarUser(user)
    }
  }, [user])
}

// export const useBannerShow = (isBannerVisible: boolean, bannerId: string, bannerCtaUrl?: string) => {
//   const { pageId, slug } = useContext(PageContext)
//   const bannerShowEventLogged = useRef(false)

//   useEffect(() => {
//     if (isBannerVisible && !bannerShowEventLogged.current) {
//       gnarSpec.bannerShow(bannerId, pageId, slug, bannerCtaUrl)
//       bannerShowEventLogged.current = true
//     }
//   }, [bannerId, bannerCtaUrl, isBannerVisible, pageId, slug])
// }
